import React from 'react';
import '../styles/GlobalDesign.css';

function WhatsAppButton() {
  const handleClick = () => {
    window.open('https://wa.me/message/SIWSZEADK2LLL1', '_blank');
  };

  return (
    <div className="whatsapp-float-wrapper">
      <button
        className="whatsapp-float"
        onClick={handleClick}
        aria-label="Contact WhatsApp"
      >
        {/* Pulse ring */}
        <span className="whatsapp-pulse" />
        {/* Official WhatsApp icon */}
        <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="whatsapp-icon">
          <circle cx="24" cy="24" r="24" fill="#25D366"/>
          <path d="M34.3 13.6A14.4 14.4 0 0 0 24 9.6C16.1 9.6 9.6 16.1 9.6 24c0 2.5.7 5 1.9 7.2L9.6 38.4l7.4-1.9A14.4 14.4 0 0 0 24 38.4c7.9 0 14.4-6.5 14.4-14.4 0-3.8-1.5-7.4-4.1-10.4zM24 36c-2.2 0-4.3-.6-6.2-1.7l-.4-.3-4.4 1.1 1.1-4.3-.3-.5A11.9 11.9 0 0 1 12 24c0-6.6 5.4-12 12-12s12 5.4 12 12-5.4 12-12 12zm6.6-9c-.3-.2-2-.9-2.3-1s-.5-.2-.7.2c-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.5-.5.1-.2.2-.3.3-.5.1-.2.1-.4 0-.5-.1-.2-.7-1.7-1-2.3-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1.1 1.1-1.1 2.6s1.1 3 1.3 3.2c.2.2 2.2 3.4 5.3 4.7.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2.1-1.5.3-.7.3-1.3.2-1.5-.1-.1-.3-.2-.6-.3z" fill="#fff"/>
        </svg>
        <span className="whatsapp-label">Chat</span>
      </button>
      <span className="whatsapp-tooltip-text">Besoin d'aide ?</span>
    </div>
  );
}

export default WhatsAppButton;
